<script context="module">
    import { apiMethods } from "../../../Services/index.svelte";

    export const getSubmitBtnDisable = (data) => {
        let res = {
            disable: false,
            tooltip: "",
        };

        if (!data.hasOwnProperty("name") || data.name == "") {
            res.disable = true;
            res.tooltip = "Name is required";
            return res;
        }

        if (!data.hasOwnProperty("type") || data.type == 0) {
            res.disable = true;
            res.tooltip = "Billing rule is required";
            return res;
        }

        if (!data.hasOwnProperty("oopType")) {
            res.disable = true;
            res.tooltip = "OOP type is required";
            return res;
        }

        return res;
    };

    export const getSliceConfigByRuleType = (type) => {
        let amountSelectorMin = 0,
            amountSelectorMax = 0,
            amountSelector = 0,
            divisionDivider = 1;

        switch (type) {
            case 2:
                //unit value
                amountSelectorMin = 40;
                amountSelectorMax = 94;
                amountSelector = 40;
                divisionDivider = 0.05;
                break;
            case 3:
                //oop
                amountSelectorMin = 0;
                amountSelectorMax = 500;
                amountSelector = 250;
                break;

            case 4:
                //hourly rate
                amountSelectorMin = 200;
                amountSelectorMax = 1500;
                amountSelector = 400;
                break;

            case 5:
                //total fee
                amountSelectorMin = 100;
                amountSelectorMax = 2000;
                amountSelector = 600;
                break;

            case 6:
            case 7:
            case 8:
            case 9:
            case 10:
            case 11:
            case 12:
            case 13:
                //all the other
                amountSelectorMin = 100;
                amountSelectorMax = 450;
                amountSelector = 125;
                divisionDivider = 1;
                break;
        }

        return {
            amountSelectorMin,
            amountSelectorMax,
            amountSelector,
            divisionDivider,
        };
    };

    export const resetAllDefaultBillingRules = async (billingRules = []) => {
        const allDefaultBillingRules = billingRules.filter(
            (br) => br.isDefault,
        );

        if (!allDefaultBillingRules.length) return;

        const batchApiCallNumber = 5;
        let numOfFinishedApis = 0;

        while (numOfFinishedApis < allDefaultBillingRules.length) {
            let numberOfThisBatch = 0,
                promises = [];

            while (numberOfThisBatch < batchApiCallNumber) {
                const billingRule =
                    allDefaultBillingRules[
                        numOfFinishedApis + numberOfThisBatch
                    ];

                billingRule &&
                    promises.push(
                        apiMethods.putMethod.updateBillingRule({
                            ...billingRule,
                            isDefault: false,
                        }),
                    );

                numberOfThisBatch++;
            }

            await Promise.all(promises);
            numOfFinishedApis += batchApiCallNumber;
        }
    };
</script>
